<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dZqVIJ/tc-custom/1.png?1688985128428?1725650247864" alt="This image is the cover for the book The Ghost Who Lived in the Cupboard"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Ghost Who Lived in the Cupboard
      </h1>
      <p class="bookDescription body article font2">
        <p>A touching story about Daniel, a boy who moves with his parents into a rambling and old country house. Aged ten, Daniel meets and becomes friends with Conrad, the resident thirteenth-century ghost, who lives in the walk-in wardrobe in Daniel's bedroom. As time passes, Daniel grows up but Conrad ages no further… Can their friendship survive the passage of time?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rita M. Hopkins
      </h2>
      
      <p class="authorDescription body article">Rita is married with adult sons, grand-children, a dog called Talia and a bearded dragon lizard known as Ig. As well as being a writer, she is an avid reader too. Further interests include gardening, nature, crafts and sewing. She would love to learn brickwork and is fascinated by mini-diggers! Having initially been involved with primary education when her own sons were at school, she went on to work as a dinner-lady, managing out-of-hours clubs and working as a classroom assistant, predominantly supporting ethnic minority children with literacy and numeracy. At the tender age of 75 years, she is now fully retired and concentrating on writing for children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8b7f2aaa